module.exports = __webpack_public_path__ + "img/service02.11ff1181.svg";